import nexus from '@db2b/nexus-js'

const state = {
  all: []
}

const getters = {
  all: state => state.all,
  current: state => state.all.find(statistics => statistics.user.id === user().id)
}

const actions = {
  load ({commit, state}) {
    return nexus.get('callcenter', '/users/statistics')
      .then(response => {
        state.all = response.data.data
      })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./libs/@db2b/keystone/store/modules/callcenter/user_statistics.js